import { RouteNames } from '@/shared/config/routes';
import { MANUAL_NODES } from '@/shared/config/manual';
import type { NavigationItem } from './types';

export const STATIC_MENU_ITEMS: NavigationItem[] = [
  {
    code: 'DASHBOARD',
    label: 'Dashboard',
    icon: 'LayoutDashboard',
    helpContentId: MANUAL_NODES.DASHBOARD,
    subItems: [
      {
        code: 'DASHBOARD_STORAGE',
        label: 'Storage Overview',
        path: RouteNames.DASHBOARD_STORAGE,
        icon: 'Database',
        helpContentId: MANUAL_NODES.STORAGE_OVERVIEW
      },
      {
        code: 'DASHBOARD_TRANSPORT',
        label: 'Transport Overview',
        path: RouteNames.DASHBOARD_TRANSPORT,
        icon: 'Package',
        helpContentId: MANUAL_NODES.TRANSPORT_OVERVIEW
      },
      {
        code: 'DASHBOARD_SERVICE_USERS',
        label: 'Service Users',
        path: RouteNames.DASHBOARD_SERVICE_USERS,
        icon: 'Users',
        helpContentId: MANUAL_NODES.SERVICE_USERS
      },
      {
        code: 'DASHBOARD_MAPPING',
        label: 'Mapping',
        path: RouteNames.DASHBOARD_MAPPING,
        icon: 'Map',
        helpContentId: MANUAL_NODES.MAPPING
      }
    ]
  }
];

export const DEFAULT_ICON = 'FileText';

/**
 * Manual node per dynamic (backend-driven) menu item code.
 */
export const MENU_ITEM_MANUAL_NODES: Record<string, number> = {
  CONSIGNMENTS_GROUP: MANUAL_NODES.CONSIGNMENTS_LIST,
  CRQ: MANUAL_NODES.CONSIGNMENTS_LIST,
  SERVICE_REQUESTS: MANUAL_NODES.ONLINE_SRFS_LIST,
  RECEIVES_GROUP: MANUAL_NODES.RECEIVE,
  DLV: MANUAL_NODES.RECEIVE,
  RECEIVE_HISTORY: MANUAL_NODES.RECEIVE_HISTORY,
  RECEIVE_LOSSES: MANUAL_NODES.RECEIVE_LOSSES,
  DSP: MANUAL_NODES.DISPATCH_PLANNING_STOCK_ON_HAND,
  WHM: MANUAL_NODES.WAREHOUSE_MANAGEMENT,
  RPT: MANUAL_NODES.REPORT_TRANSPORT_PLANNING
};
